import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles(() => ({
  scrollingContainer: {
    overflow: "auto",
  },
}));

export default useStyles;
